import { render, staticRenderFns } from "./ReceiveDetails_Details.vue?vue&type=template&id=07202746&"
import script from "./ReceiveDetails_Details.vue?vue&type=script&lang=js&"
export * from "./ReceiveDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports